/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".sidebar__info--flight-info[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{margin-top:2rem;margin-bottom:2rem}.message_box[_ngcontent-%COMP%]{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;margin:20px 0}.message_box[_ngcontent-%COMP%]   app-svg[_ngcontent-%COMP%]{width:3rem;height:3rem;margin-right:5px}"];
export { styles as styles };
